/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */


import { useEffect, useState } from 'react';
import axios from 'axios';
import { unAuthenticatedApiService } from 'services/service';
import {
    useToast,
} from '@chakra-ui/react';

export const useGetCountries = () => {
    const [countries, setCountries] = useState([]);
    const fetchCountries = async () => {
        try {
            const response = await unAuthenticatedApiService.get(
                `/requests/terminalAfrica/get-countries`,
            );
            setCountries(response?.data?.data);
            return response?.data;
        } catch (error) {
            console.log('Error from countries', error);
        }
    };
    useEffect(() => {
        fetchCountries();
    }, []);
    return countries;
};
export const useGetStatesByCountryId = (countryId) => {
    const [states, setStates] = useState([]);
    const params = {
        country_code: countryId,
    };
    const query = new URLSearchParams(params);
    const fetchStates = async () => {
        try {
            const response = await unAuthenticatedApiService.get(
                `/requests/terminalAfrica/get-states?${query}`,
            );
            setStates(response?.data?.data);
            return response?.data;
        } catch (error) {
            console.log('Error from states', error);
        }
    };
    useEffect(() => {
        if (countryId) fetchStates();
    }, [countryId]);
    return states;
};
export const useGetCitiesByStateId = (stateCode, countryCode) => {
    const [citites, setCitites] = useState([]);
    const params = {
        country_code: countryCode,
        state_code: stateCode,
    };
    const query = new URLSearchParams(params);
    const fetchCitites = async () => {
        try {
            const response = await unAuthenticatedApiService.get(
                `/requests/terminalAfrica/get-cities?${query}`,
            );
            setCitites(response?.data?.data);
            return response?.data;
        } catch (error) {
            console.log('Error from cities', error);
        }
    };
    useEffect(() => {
        if (stateCode) fetchCitites();
    }, [stateCode]);
    return citites;
};

export const useGetCarriers = () => {
    const [carriers, setCarriers] = useState([]);
    const fetchCarriers = async () => {
        try {
            const response = await unAuthenticatedApiService.get(
                '/requests/terminalAfrica/get-carriers',
            );

            setCarriers(response?.data?.data);
            return response?.data;
        } catch (error) {
            console.log('Error from carriers', error);
        }
    };
    useEffect(() => {
        fetchCarriers();
    }, []);
    return { carriers, fetchCarriers };
};

export const useGetQoutesAndCarriers = () => {
  const [bestCarrier, setBestCarrier] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const LOGISTICS_BASE_URL = process.env.REACT_APP_LOGISTICS_BASE_URL ;
  const LOGISTICS_TOKEN = process.env.REACT_APP_LOGISTICS_TOKEN;

  const routeMatch = async (payload) => {
    setIsLoading(true);
    try {
      if (payload?.carrier_id === "pickup") {
        return null;
      }
      console.log('Payload for logistics match:', payload);
      const response = await axios.post(`${LOGISTICS_BASE_URL}/routes/match`, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${LOGISTICS_TOKEN}`
        }
      });

      if (response.data?.data && Array.isArray(response.data.data)) {
        // Handle array of grouped shipments
        const shipments = response.data.data;
        const formattedShipments = shipments.map(shipment => ({
          id: shipment.rate_id || 'obana_logistics_match',
          rate_id: shipment.rate_id || 'obana_logistics_match',
          carrier_name: shipment.carrier?.name || 'Obana Logistics',
          carrier_logo: shipment.carrier?.logo || '/path/to/obana_logo.png',
          amount: shipment.match.price,
          delivery_time: shipment.match.estimated_delivery,
          delivery_eta: shipment.match.eta,
          carrier_rate_description: `${shipment.items.length} item(s) via ${shipment.carrier?.name || 'Obana Logistics'}`,
          items: shipment.items,
          metadata: {
            ...shipment,
            is_external: shipment.external,
          },
        }));
        setBestCarrier(formattedShipments);
        return formattedShipments;
      } else if (response.data?.data) {
        const matchedRoute = response.data.data;
        const formattedCarrier = {
          id: matchedRoute.rate_id || 'obana_logistics_match',
          rate_id: matchedRoute.rate_id || 'obana_logistics_match',
          carrier_name: matchedRoute.carrier?.name || 'Obana Logistics',
          carrier_logo: matchedRoute.carrier?.logo || '/path/to/obana_logo.png',
          amount: matchedRoute.match.price,
          delivery_time: matchedRoute.match.estimated_delivery,
          delivery_eta: matchedRoute.match.eta,
          carrier_rate_description: `Best available option via ${matchedRoute.carrier?.name || 'Obana Logistics'}`,
          items: matchedRoute.items || [],
          metadata: {
            ...matchedRoute,
            is_external: matchedRoute.external,
          },
        };
        setBestCarrier([formattedCarrier]);
        return [formattedCarrier];
      } else {
        toast({
          title: 'No routes found',
          description: response.data?.message || 'Could not find a matching route for your shipment.',
          status: 'info',
          duration: 5000,
          isClosable: true,
          position: 'top-right'
        });
        setBestCarrier(null);
        return null;
      }
    } catch (err) {
      console.error('Error fetching logistics rates:', err?.response?.data || err.message);
      toast({
        title: 'Error fetching rates',
        description: err?.response?.data?.message || err.message || 'Failed to connect to logistics service.',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right'
      });
      
      setBestCarrier(null);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { routeMatch, bestCarrier, setBestCarrier, isLoading };
};

export const useGetQoute = () => {
    const [quote, setQuote] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const fetchQuote = async (payload) => {
        setIsLoading(true);
        try {
            if (payload?.carrier_id === 'pickup') {
                setQuote(0);
                return 0;
            } else {
                const response = await unAuthenticatedApiService.post({
                    url: '/requests/terminalAfrica/get-qoute',
                    payload,
                });
                setQuote(response?.data?.data?.[0]?.amount);
                return response?.data?.data?.[0]?.amount;
            }
        } catch (error) {
            console.log('Error from carriers', error);
        } finally {
            setIsLoading(false);
        }
    };
    return { quote, fetchQuote, isLoading };
};
